import * as React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { getImageURL } from '../../../common/utils/CardUtils';
import { analytics } from '../../../core/Constants';
import { OffersCardTile } from './Notifications/OffersCardTile';
import { NotificationSkeleton } from '../../../common/StatusUnavailableNotifications/StatusUnavailable';

export const SweepstakesTile = ({
  sweepstakesData = {},
  hasError = false,
  isLoading = false,
}) => {
  const { title, image, totalEntriesAvailable, totalEntriesCompleted } = sweepstakesData;
  // Handle loading state
  if (isLoading) {
    return <NotificationSkeleton />;
  }

  // Extract data from sweepstakes API response or use fallbacks
  const titleText = title || 'New Sweepstakes!';
  const imageUrl = image || 'Pro-Xtra_Perk_Icon-whiteFill.svg';
  let linkText = 'New Entry Available';

  if (totalEntriesCompleted === 0) {
    linkText = 'Enter Giveaway';
  } else if (totalEntriesCompleted >= totalEntriesAvailable) {
    linkText = 'All Entries Earned';
  }

  // Handle error state with sweepstakes-specific messaging
  if (hasError) {
    return (
      <div className="sui-flex sui-flex-row sui-items-center sui-justify-start sui-w-full sui-py-3">
        <div className="">
          <img
            src={getImageURL('Pro-Xtra_Perk_Icon-whiteFill.svg')}
            width="48px"
            height="48px"
            alt="Sweepstakes Icon"
          />
        </div>
        <div className="sui-flex sui-flex-col notification-unavailable">
          <div className="sui-flex sui-flex-col sui-justify-center">
            <Typography variant="body-base" height="tight" weight="regular" color="inactive">
              Sweepstakes Unavailable
            </Typography>
          </div>
          <div>
            <div aria-hidden="true" onClick={() => window.location.reload()}><u>Refresh</u></div>
          </div>
        </div>
      </div>
    );
  }

  // Use OffersCardTile for consistent styling and behavior
  return (
    <OffersCardTile
      imageURL={imageUrl}
      imageClass="sui-w-100 sui-pt-1"
      analyticsMessage={analytics.ANALYTICS_MESSAGE.SWEEPSTAKES}
      analyticsLinks={analytics.ANALYTICS_LINKS.SWEEPSTAKES}
      refLink="/myaccount/proXtraRewards?drawerList=sweepstakes"
      altText="Sweepstakes Image"
      linkText={linkText}
    >
      <Typography variant="body-base" weight="bold" height="normal">
        {titleText}
      </Typography>
    </OffersCardTile>
  );
};